import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractTypeaheadSearchComponent } from '@motivforce/mx-library-angular';
import { debounceTime, distinctUntilChanged, merge, Observable, of, Subject, switchMap } from 'rxjs';
import { User } from 'src/app/core/model/user';

@Component({
  selector: 'app-user-email-typeahead',
  templateUrl: './user-email-typeahead.component.html',
  styleUrls: ['./user-email-typeahead.component.scss'],
})
export class UserEmailTypeaheadComponent extends AbstractTypeaheadSearchComponent {
  @Input() placeholder = '';
  @Input() users: User[] = [];
  @Input() labelFunction: (item: User) => string = (item: User) => `${item.email}`;
  focus$ = new Subject<string>();

  @Output() valueChange = new EventEmitter<string>();
  resultFormatter = (user: User) => this.labelFunction(user);
  inputFormatter = (user: User) => `${user.email}`;

  override typeaheadSearch = (term: string): Observable<User[]> => {
    const lowerTerm = term.toLowerCase();

    return of(this.users.filter((user) => this.resultFormatter(user).toLowerCase().includes(lowerTerm)));
  };

  override ngbTypeahead = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());

    return merge(debouncedText$, this.focus$).pipe(switchMap((term) => this.typeaheadSearch(term)));
  };

  onInput(input: HTMLInputElement) {
    this.valueChange.emit(input.value);
  }

  onSelect(event: any) {
    this.valueChange.emit(event.item.email);
  }
}
